export default __webpack_public_path__ + "assets/no-hotel1.png";